import React from 'react';
import { EyeIcon, EyeOffIcon } from 'lucide-react';
interface BalanceCardProps {
  balance: number;
  currency: string;
  showBalance: boolean;
  onToggleVisibility: () => void;
}
export function BalanceCard({
  balance,
  currency,
  showBalance,
  onToggleVisibility
}: BalanceCardProps) {
  const formatBalance = (amount: number) => {
    return new Intl.NumberFormat('fr-FR').format(amount);
  };
  return <div className="bg-gradient-to-br from-amber-500 to-orange-500 rounded-2xl p-6 shadow-lg text-white" data-id="element-40">
      <div className="flex items-center justify-between mb-6" data-id="element-41">
        <div data-id="element-42">
          <p className="text-amber-100 text-sm mb-1" data-id="element-43">Solde disponible</p>
          <div className="flex items-baseline gap-2" data-id="element-44">
            {showBalance ? <>
                <span className="text-4xl font-bold" data-id="element-45">
                  {formatBalance(balance)}
                </span>
                <span className="text-xl font-medium text-amber-100" data-id="element-46">
                  {currency}
                </span>
              </> : <span className="text-4xl font-bold" data-id="element-47">••••••</span>}
          </div>
        </div>
        <button onClick={onToggleVisibility} className="p-2 hover:bg-white/20 rounded-lg transition-colors" data-id="element-48">
          {showBalance ? <EyeOffIcon className="w-6 h-6" data-id="element-49" /> : <EyeIcon className="w-6 h-6" data-id="element-50" />}
        </button>
      </div>

      <div className="flex items-center gap-2 text-sm text-amber-100" data-id="element-51">
        <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse" data-id="element-52" />
        <span data-id="element-53">Compte actif</span>
      </div>
    </div>;
}